import { render, staticRenderFns } from "./FlipCounter.vue?vue&type=template&id=0252725f&scoped=true"
import script from "./FlipCounter.vue?vue&type=script&lang=js"
export * from "./FlipCounter.vue?vue&type=script&lang=js"
import style0 from "./FlipCounter.vue?vue&type=style&index=0&id=0252725f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0252725f",
  null
  
)

export default component.exports